/**
 * da-dually.js — Da Offset Dually Wheel Set Configurator
 * Companion to snippets/da-dually-builder.liquid
 */
(function () {
  'use strict';

  var OPT_LABELS = {
    single: 'SINGLE WHEEL',
    pair:   'MATCHED PAIR',
    outers: '4 OUTERS',
    full:   'FULL SET OF 6'
  };

  function fmtPrice(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }

  function etLabel(et) {
    return (et > 0 ? '+' : '') + et + 'mm ET';
  }

  // -------------------- Da Offset popup --------------------

  function injectPopupStyles() {
    if (document.getElementById('da-dually-popup-styles')) return;
    var css = [
      '.wdr-overlay-dly{position:fixed;inset:0;background:rgba(0,0,0,0.75);z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;font-family:"Bebas Neue",Impact,sans-serif;}',
      '.wdr-modal-dly{background:#CDCDCD;max-width:400px;width:100%;border-radius:6px;overflow:hidden;position:relative;}',
      '.wdr-bar-dly{height:3px;background:#B1282E;}',
      '.wdr-header-dly{background:#111;color:#fff;padding:16px;display:flex;align-items:center;gap:12px;justify-content:center;}',
      '.wdr-icon-dly{width:34px;height:34px;border-radius:50%;background:#B1282E;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
      '.wdr-title-dly{font-size:28px;line-height:1;letter-spacing:0.5px;text-align:center;}',
      '.wdr-body-dly{padding:18px;color:#111;font-family:"Bebas Neue",Impact,sans-serif;font-size:21px;line-height:1.3;text-align:center;letter-spacing:0.3px;}',
      '.wdr-body-dly a{color:#B1282E;text-decoration:underline;}',
      '.wdr-body-dly em{font-family:"Inter",sans-serif;font-size:14px;font-style:normal;color:#5D6266;display:block;margin-top:8px;}',
      '.wdr-button-dly{width:100%;background:#111;color:#fff;border:none;padding:14px;font-family:"Bebas Neue",Impact,sans-serif;font-size:24px;letter-spacing:1.5px;cursor:pointer;border-top:1px solid #b8b8b8;}',
      '.wdr-button-dly:hover{background:#2a2a2a;}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'da-dually-popup-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function showPopup(title, bodyHtml, onClose) {
    injectPopupStyles();
    var overlay = document.createElement('div');
    overlay.className = 'wdr-overlay-dly';
    overlay.innerHTML =
      '<div class="wdr-modal-dly">' +
        '<div class="wdr-bar-dly"></div>' +
        '<div class="wdr-header-dly">' +
          '<div class="wdr-icon-dly">' +
            '<svg viewBox="0 0 22 22" width="22" height="22" aria-hidden="true">' +
              '<path fill="#fff" d="M11 2.5 L20.5 19.5 L1.5 19.5 Z" />' +
              '<rect x="10" y="7.5" width="2" height="6.5" fill="#B1282E"/>' +
              '<rect x="10" y="15.5" width="2" height="2" fill="#B1282E"/>' +
            '</svg>' +
          '</div>' +
          '<div class="wdr-title-dly">' + title + '</div>' +
        '</div>' +
        '<div class="wdr-body-dly">' + bodyHtml + '</div>' +
        '<button type="button" class="wdr-button-dly">GOT IT</button>' +
      '</div>';
    document.body.appendChild(overlay);
    var close = function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      if (typeof onClose === 'function') onClose();
    };
    overlay.querySelector('.wdr-button-dly').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
  }

  // -------------------- Builder class --------------------

  function DaDuallyBuilder(root) {
    this.root = root;
    this.role = root.dataset.role;
    this.currentVariantId = parseInt(root.dataset.currentVariantId, 10);

    var dataEl = root.querySelector('[data-dually-family]');
    try {
      this.family = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[da-dually] Failed to parse family data', e);
      root.style.display = 'none';
      return;
    }

    this.hasFront  = !!this.family.front;
    this.hasRear   = !!(this.family.rears && this.family.rears.length);
    this.hasInner  = !!this.family.inner;
    this.multiRear = this.hasRear && this.family.rears.length > 1;

    this.selectedOption  = 'full';
    this.selectedRearIdx = 0;

    this.init();
  }

  DaDuallyBuilder.prototype.init = function () {
    this.applyOptionConstraints();
    this.populateRearSelector();
    this.bindEvents();
    this.refresh();
  };

  DaDuallyBuilder.prototype.applyOptionConstraints = function () {
    var $ = this.root.querySelector.bind(this.root);
    var optOuters = $('[data-opt="outers"]');
    var optFull   = $('[data-opt="full"]');

    if (!this.hasFront || !this.hasRear) {
      if (optOuters) optOuters.style.display = 'none';
      if (optFull)   optFull.style.display = 'none';
      this.selectedOption = 'pair';
      var pairInput = $('input[value="pair"]');
      if (pairInput) pairInput.checked = true;
      return;
    }

    if (!this.hasInner) {
      var fullTag = $('[data-full-tag]');
      if (fullTag) fullTag.textContent = '4 outers + inquire for inners';
    }
  };

  DaDuallyBuilder.prototype.populateRearSelector = function () {
    var optionsWrap = this.root.querySelector('[data-rear-options]');
    var hint        = this.root.querySelector('[data-rear-hint]');
    var self        = this;

    if (this.role === 'rear_outer') {
      // On rear product pages — default the selected rear to the one being viewed,
      // but still build the chooser so customer can switch
      var idx = this.family.rears.findIndex(function (r) {
        return r.variant_id === self.currentVariantId;
      });
      this.selectedRearIdx = idx >= 0 ? idx : 0;
      // Fall through to the multiRear logic below to build the cards
    }

    if (!this.hasRear) return;

    if (this.multiRear) {
      // Build card-style pill options
      optionsWrap.innerHTML = '';
      this.family.rears.forEach(function (rear, idx) {
        var label = document.createElement('label');
        label.className = 'da-dly-rear-opt' + (idx === self.selectedRearIdx ? ' is-selected' : '');
        label.setAttribute('data-rear-idx', idx);

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'dao-d-rear-' + self.currentVariantId;
        input.value = idx;
        input.className = 'da-dly-sr-only';
        if (idx === self.selectedRearIdx) input.checked = true;

        var nameSpan = document.createElement('span');
        nameSpan.className = 'da-dly-rear-opt-name';
        nameSpan.textContent = rear.label;

        var metaSpan = document.createElement('span');
        metaSpan.className = 'da-dly-rear-opt-meta';
        metaSpan.textContent = etLabel(rear.et) + ' · ' + fmtPrice(rear.price);

        label.appendChild(input);
        label.appendChild(nameSpan);
        label.appendChild(metaSpan);

        label.addEventListener('click', function () {
          input.checked = true;
          self.selectedRearIdx = idx;
          // Update visual state on all rear cards
          optionsWrap.querySelectorAll('.da-dly-rear-opt').forEach(function (el) {
            el.classList.toggle('is-selected', parseInt(el.dataset.rearIdx, 10) === idx);
          });
          self.refresh();
        });

        optionsWrap.appendChild(label);
      });
      optionsWrap.style.display = 'grid';
      hint.style.display = 'none';
    } else {
      // Single-rear family — show static hint, no selector
      optionsWrap.style.display = 'none';
      var r = this.family.rears[0];
      hint.textContent = 'Rear: ' + r.label + ' · ' + etLabel(r.et) + ' · ' + fmtPrice(r.price);
      hint.style.display = 'block';
    }
  };

  DaDuallyBuilder.prototype.findCurrentRearInFamily = function () {
    var id = this.currentVariantId;
    return (this.family.rears || []).find(function (r) { return r.variant_id === id; }) || null;
  };

  DaDuallyBuilder.prototype.bindEvents = function () {
    var self = this;
    this.root.querySelectorAll('[data-opt]').forEach(function (label) {
      if (label.style.display === 'none') return;
      label.addEventListener('click', function () {
        var input = label.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          self.selectedOption = input.value;
          self.refresh();
        }
      });
    });
    // Note: rear option cards bind their own click listeners during populateRearSelector()
    this.root.querySelector('[data-cta]').addEventListener('click', function () {
      self.addToCart();
    });
  };

  DaDuallyBuilder.prototype.selectedRear = function () {
    return (this.family.rears && this.family.rears[this.selectedRearIdx]) || null;
  };

  DaDuallyBuilder.prototype.currentSku = function () {
    if (this.role === 'front' && this.family.front) return this.family.front.sku;
    if (this.role === 'rear_outer') {
      var r = this.findCurrentRearInFamily();
      return r ? r.sku : '';
    }
    return '';
  };

  DaDuallyBuilder.prototype.currentPrice = function () {
    if (this.role === 'front' && this.family.front) return this.family.front.price;
    if (this.role === 'rear_outer') {
      var r = this.findCurrentRearInFamily();
      return r ? r.price : 0;
    }
    return 0;
  };

  DaDuallyBuilder.prototype.calcTotals = function () {
    var cur   = this.currentPrice();
    var front = this.family.front ? this.family.front.price : 0;
    var rearP = this.selectedRear() ? this.selectedRear().price : 0;
    var inner = this.family.inner ? this.family.inner.price : 0;
    return {
      single: cur,
      pair:   cur * 2,
      outers: (front * 2) + (rearP * 2),
      full:   (front * 2) + (rearP * 2) + (this.hasInner ? inner * 2 : 0)
    };
  };

  DaDuallyBuilder.prototype.buildLineItems = function () {
    var opt = this.selectedOption;
    var items = [];

    if (opt === 'single') {
      items.push({ id: this.currentVariantId, quantity: 1 });
    } else if (opt === 'pair') {
      items.push({ id: this.currentVariantId, quantity: 2 });
    } else if (opt === 'outers' || opt === 'full') {
      if (this.family.front)   items.push({ id: this.family.front.variant_id, quantity: 2 });
      if (this.selectedRear()) items.push({ id: this.selectedRear().variant_id, quantity: 2 });
      if (opt === 'full' && this.family.inner) {
        items.push({ id: this.family.inner.variant_id, quantity: 2 });
      }
    }

    var merged = {};
    items.forEach(function (it) {
      merged[it.id] = (merged[it.id] || 0) + it.quantity;
    });
    return Object.keys(merged).map(function (id) {
      return { id: parseInt(id, 10), quantity: merged[id] };
    });
  };

  DaDuallyBuilder.prototype.buildPreviewLines = function () {
    var opt = this.selectedOption;
    var lines = [];
    var front = this.family.front;
    var rear  = this.selectedRear();
    var inner = this.family.inner;

    function line(qty, sku, descr, eachPrice) {
      return '<span class="da-dly-line">' +
        qty + '× <span class="da-dly-sku">' + sku + '</span> ' + descr +
        ' — ' + fmtPrice(eachPrice) + (qty > 1 ? ' ea' : '') +
      '</span>';
    }

    if (opt === 'single') {
      lines.push(line(1, this.currentSku(), '(this wheel)', this.currentPrice()));
    } else if (opt === 'pair') {
      lines.push(line(2, this.currentSku(), '(this wheel)', this.currentPrice()));
    } else if (opt === 'outers') {
      if (front) lines.push(line(2, front.sku, 'Front ' + etLabel(front.et), front.price));
      if (rear)  lines.push(line(2, rear.sku,  'Rear ' + rear.label + ' (' + rear.et + 'mm ET)', rear.price));
    } else if (opt === 'full') {
      if (front) lines.push(line(2, front.sku, 'Front ' + etLabel(front.et), front.price));
      if (rear)  lines.push(line(2, rear.sku,  'Rear ' + rear.label + ' (' + rear.et + 'mm ET)', rear.price));
      if (inner) lines.push(line(2, inner.sku, 'Inner blank', inner.price));
      else       lines.push('<span class="da-dly-line"><em>Inner blanks not available — contact us for compatible inners</em></span>');
    }
    return lines;
  };

  DaDuallyBuilder.prototype.refresh = function () {
    var totals = this.calcTotals();
    var $ = this.root.querySelector.bind(this.root);
    var self = this;

    Object.keys(totals).forEach(function (opt) {
      var el = $('[data-price="' + opt + '"]');
      if (el) el.textContent = fmtPrice(totals[opt]);
    });

    this.root.querySelectorAll('[data-opt]').forEach(function (el) {
      el.classList.toggle('is-selected', el.dataset.opt === self.selectedOption);
    });

    var needsRear = (this.selectedOption === 'outers' || this.selectedOption === 'full') && this.hasRear && this.multiRear;
    $('[data-rear-wrap]').style.display = needsRear ? 'block' : 'none';

    $('[data-no-inner-note]').style.display = (this.selectedOption === 'full' && !this.hasInner) ? 'block' : 'none';

    $('[data-preview-lines]').innerHTML = this.buildPreviewLines().join('');

    var cta = $('[data-cta]');
    cta.textContent = 'ADD ' + OPT_LABELS[this.selectedOption] + ' TO CART — ' + fmtPrice(totals[this.selectedOption]);
  };

  DaDuallyBuilder.prototype.addToCart = function () {
    var self = this;
    var cta  = this.root.querySelector('[data-cta]');
    var items = this.buildLineItems();

    if (!items.length) {
      showPopup('NOTHING SELECTED', 'Pick a configuration above to add to cart.');
      return;
    }

    cta.disabled = true;
    cta.classList.add('is-loading');
    cta.textContent = 'ADDING...';

    if (self.selectedOption === 'full' && !self.hasInner) {
      try { sessionStorage.setItem('da-dually-inners-needed', '1'); } catch (e) {}
    }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
    .then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, status: res.status, data: data };
      });
    })
    .then(function (result) {
      if (!result.ok) {
        cta.disabled = false;
        cta.classList.remove('is-loading');
        self.refresh();
        self.handleCartError(result.data, items);
        return;
      }
      window.location.href = '/cart';
    })
    .catch(function (err) {
      console.error('[da-dually] Cart add error', err);
      cta.disabled = false;
      cta.classList.remove('is-loading');
      self.refresh();
      showPopup('SOMETHING WENT WRONG', 'Please refresh the page and try again.<em>If this keeps happening, contact support@daoffset.com.</em>');
    });
  };

  DaDuallyBuilder.prototype.handleCartError = function (data, items) {
    var msg = (data && (data.description || data.message)) || 'One or more items are out of stock.';
    var self = this;
    var skus = items.map(function (it) {
      if (self.family.front && self.family.front.variant_id === it.id) return self.family.front.sku;
      if (self.family.inner && self.family.inner.variant_id === it.id) return self.family.inner.sku;
      var r = (self.family.rears || []).find(function (x) { return x.variant_id === it.id; });
      if (r) return r.sku;
      return 'this wheel';
    });
    var skuList = [];
    skus.forEach(function (s) { if (skuList.indexOf(s) < 0) skuList.push(s); });
    showPopup('OUT OF STOCK', msg + '<em>Attempted SKUs: ' + skuList.join(', ') + '</em>');
  };

  // -------------------- Boot --------------------

  function initAll() {
    var roots = document.querySelectorAll('[data-da-dually]');
    roots.forEach(function (el) {
      if (el.dataset.daDuallyInit === '1') return;
      el.dataset.daDuallyInit = '1';
      new DaDuallyBuilder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Force a fresh page load when arriving via back/forward navigation.
  // Catches both bfcache restores (event.persisted=true) AND regular back-button
  // navigations where the browser served a cached HTML.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
      return;
    }
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') {
        window.location.reload();
      }
    } catch (e) {}
  });
})();